{
    "TODAY": "今日",
    "WEEKLY_FORECAST": "週間予報",
    "TITLE_WITH_LOCATION": "{{location}}の天気予報",
    "MIN_TEMPERATURE": "最低: {{temp}}°",
    "MAX_TEMPERATURE": "最高: {{temp}}°",
    "SUNSHINE_DURATION_HOURS": "{{duration}} 時間",
    "SUNSHINE_DURATION_LABEL": "日照時間",
    "NO_DATA_INFO": "現在、天候データを表示できません。",
    "WEATHER_CODE_0": "晴れ",
    "WEATHER_CODE_1": "快晴",
    "WEATHER_CODE_2": "一部曇り",
    "WEATHER_CODE_3": "曇り",
    "WEATHER_CODE_45": "霧",
    "WEATHER_CODE_48": "着氷性の霧",
    "WEATHER_CODE_51": "弱い霧雨",
    "WEATHER_CODE_53": "霧雨",
    "WEATHER_CODE_55": "強い霧雨",
    "WEATHER_CODE_56": "弱く凍える霧雨",
    "WEATHER_CODE_57": "強く凍える霧雨",
    "WEATHER_CODE_61": "小雨",
    "WEATHER_CODE_63": "雨",
    "WEATHER_CODE_65": "大雨",
    "WEATHER_CODE_66": "弱く凍える雨",
    "WEATHER_CODE_67": "強く凍える雨",
    "WEATHER_CODE_71": "小雪",
    "WEATHER_CODE_73": "雪",
    "WEATHER_CODE_75": "大雪",
    "WEATHER_CODE_77": "みぞれ",
    "WEATHER_CODE_80": "弱いにわか雨",
    "WEATHER_CODE_81": "にわか雨",
    "WEATHER_CODE_82": "激しいにわか雨",
    "WEATHER_CODE_85": "弱いにわか雪",
    "WEATHER_CODE_86": "激しいにわか雪",
    "WEATHER_CODE_95": "雷雨",
    "WEATHER_CODE_96": "弱い雹を伴う雷雨",
    "WEATHER_CODE_99": "強い雹を伴う雷雨",
    "WEATHER_CODE_0_NIGHT": "晴天（夜）",
    "WEATHER_CODE_1_NIGHT": "快晴（夜）",
    "WEATHER_CODE_2_NIGHT": "一部曇り（夜）",
    "WEATHER_CODE_UNKNOWN": "不明"
}
